import { useTranslation } from 'react-i18next';

export const DayOrderedShortageItem = ({ shortage }) => {

    const { t } = useTranslation('common');

    const getOrderedShortagesTitle = (shortage) => {
        return shortage.orderedShortage.map((product, index) =>
                (index + 1)
                + '. '
                + product.title
                + ' '
                + t('monthMenu:requiredShortage')
                + ' '
                + product.shortageAmount
                + t('unit.kg')
                + ' '
                + t('monthMenu:orderedRequiredShortage')
                + ' '
                + product.orderedAmount
                + t('unit.kg'))
            .join('\n');
    };

    return (
        <>
            {shortage != null && shortage.orderedShortage.length > 0
                ? <span
                    title={getOrderedShortagesTitle(shortage)}>{t('monthMenu:orderedProducts')}: {shortage.orderedShortage.length}
                  </span>
                : <span>-</span>}
        </>
    );
};